import { AXIOS } from "../config/axios.config";

class PackageService {
  async fetchPackages(
    pkgCategory?: string,
    langId?: string,
    featuredPackages?: boolean
  ) {
    return await AXIOS.get(
      `/package/getAll?pkgCategory=${pkgCategory}&lang=${langId}&featuredPackages=${featuredPackages}`
    );
  }

  async fetchPackageDetails(pkgId: string, langId: string) {
    return await AXIOS.get(`package/pkgDetail/${pkgId}?lang=${langId}`);
  }
}
export default new PackageService();
